import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-2ef82591"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "questions-container" }
const _hoisted_2 = { class: "question-primary-language" }
const _hoisted_3 = {
  key: 0,
  class: "question-secondary-language"
}
const _hoisted_4 = {
  key: 0,
  class: "response-container-two-options"
}
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "option-primary-language" }
const _hoisted_7 = {
  key: 0,
  class: "option-secondary-language"
}
const _hoisted_8 = {
  key: 1,
  class: "response-container-multi-options"
}
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "option-text" }
const _hoisted_11 = { class: "option-primary-language" }
const _hoisted_12 = {
  key: 0,
  class: "option-secondary-language"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["form-item-container", { 'first-form-item': _ctx.form_item_order === 0 && _ctx.layout_mode === 'all_on_one_page' }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.question_lang1), 1),
      (_ctx.bilingue)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.question_lang2), 1))
        : _createCommentVNode("", true)
    ]),
    (_ctx.options.length === 2)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (option, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: _normalizeClass(["option-container", { 'clicked': _ctx.clickedOption === index }]),
              key: index,
              onClick: ($event: any) => (_ctx.handleOptionClick(index))
            }, [
              _createElementVNode("span", _hoisted_6, _toDisplayString(option.text_lang1), 1),
              (_ctx.bilingue)
                ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(option.text_lang2), 1))
                : _createCommentVNode("", true)
            ], 10, _hoisted_5))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    (_ctx.options.length > 2)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (option, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              onClick: ($event: any) => (_ctx.handleOptionClick(index)),
              class: "option-container"
            }, [
              _createElementVNode("div", {
                class: _normalizeClass(["option-id", { 'clicked': _ctx.clickedOption === index }])
              }, [
                _createElementVNode("span", null, _toDisplayString(_ctx.optionsLetter[index]), 1)
              ], 2),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("span", _hoisted_11, _toDisplayString(option.text_lang1), 1),
                (_ctx.bilingue)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(option.text_lang2), 1))
                  : _createCommentVNode("", true)
              ])
            ], 8, _hoisted_9))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ], 2))
}